/* Modkingz page reveals: fades .mk-reveal elements in as they enter the viewport. */
(function () {
  var items = document.querySelectorAll('.mk-reveal');
  if (!items.length || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Anything already on screen stays visible, so nothing flashes out and back in.
  var viewport = window.innerHeight || document.documentElement.clientHeight;
  items.forEach(function (item) {
    if (item.getBoundingClientRect().top < viewport) item.classList.add('is-in');
  });

  document.documentElement.classList.add('mk-reveal-on');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  items.forEach(function (item) {
    if (!item.classList.contains('is-in')) observer.observe(item);
  });
})();
